/**
 * @generated SignedSource<<e77246669d5d6dba8b9ac66ec0ba42b9>>
 * @relayHash c8510dbcbc45640d1b68dcd2a64716ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b1bbd340c4e0c77cb0c57ebc2139b74505188fa03abe787856416e7f38a8a6a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';
import withDisplayMessage_provider from '@atlassian/jira-relay-provider/src/mbw-191-display-flags-in-case-of-no-columns.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7b1bbd340c4e0c77cb0c57ebc2139b74505188fa03abe787856416e7f38a8a6a",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw191displayflagsincaseofnocolumnsrelayprovider": withDisplayMessage_provider
    }
  }
};

export default node;
